import { onMounted, onUnmounted } from 'vue';

export function useAppWindowEvents({
  onNavigate,
  onNavigateToDetails,
  onNavigateToActivities,
  onNavigateToMap,
  onTrendingCardSearch,
  onOpenAuthModalEvent,
  onAuthRedirectHome,
} = {}) {
  const handleNavigationEvent = (event) => {
    if (event.detail) {
      onNavigate?.(event.detail);
    }
  };

  const handleDetailsNavigationEvent = (event) => {
    if (event.detail?.page === 'details') {
      onNavigateToDetails?.(event.detail.destinationId);
    }
  };

  const handleActivitiesNavigationEvent = (event) => {
    if (event.detail?.page === 'activities') {
      onNavigateToActivities?.(event.detail.destinationId);
    }
  };

  const handleMapNavigationEvent = (event) => {
    if (event.detail?.page === 'map') {
      onNavigateToMap?.(event.detail.destinationId);
    }
  };

  const listeners = [
    ['navigate', handleNavigationEvent],
    ['navigate-to-details', handleDetailsNavigationEvent],
    ['navigate-to-activities', handleActivitiesNavigationEvent],
    ['navigate-to-map', handleMapNavigationEvent],
    ['trending-card-search', onTrendingCardSearch],
    ['open-auth-modal', onOpenAuthModalEvent],
    ['auth:redirect-home', onAuthRedirectHome],
  ];

  onMounted(() => {
    listeners.forEach(([eventName, handler]) => {
      if (handler) {
        window.addEventListener(eventName, handler);
      }
    });
  });

  onUnmounted(() => {
    listeners.forEach(([eventName, handler]) => {
      if (handler) {
        window.removeEventListener(eventName, handler);
      }
    });
  });
}
